export const FETCH_DOWNLOAD_COMPLETE_REPORT_REQUEST = 'FETCH_DOWNLOAD_COMPLETE_REPORT_REQUEST'
export const FETCH_DOWNLOAD_COMPLETE_REPORT_SUCCESS = 'FETCH_DOWNLOAD_COMPLETE_REPORT_SUCCESS'
export const FETCH_DOWNLOAD_COMPLETE_REPORT_FALUIRE = 'FETCH_DOWNLOAD_COMPLETE_REPORT_FALUIRE'